export const MP_UI_TOPBAR_HEIGHT = 71 // topbar + separator
export const APP_CONTAINER_WIDTH = 1080
export const APP_CONTAINER_WIDE_WIDTH = 1170
export const APP_CONTAINER_SELECTOR = 'main'
export const APP_CONTAINER_SELECTOR_FRAMEWORK = '#mpui-fw-main-section'

export const UHQM_HIDDEN_POPUPS_LOCAL_STORAGE_KEY = 'uhqm.popup.topics'
export const UHQM_SIDEBAR_ANIMATION_DURATION = 200
export const UHQM_SESSION_STORAGE_KEY = 'uhqm-navigation-state-restore'
